module.exports = __webpack_public_path__ + "img/slider2new.334bb37b.png";